import { IColorScheme } from '@services/BrandingsService';

export type { IColorScheme };

export interface IBranding {
  id: string;
  name: string;
  isActive: boolean;
  brandingColors?: IColorScheme;
  timestamp?: number;
}

export function mapBrandingFromApi(
  b: {
    brandingId?: string;
    id?: string;
    name?: string;
    brandingColors?: IColorScheme;
    timestamp?: number;
    [key: string]: unknown;
  },
  index: number,
  activeBrandingId?: string | null,
): IBranding {
  const id = (b.brandingId ?? b.id ?? String(index)) as string;

  return {
    id,
    name: (b.name ?? 'Unnamed') as string,
    isActive: activeBrandingId ? id === activeBrandingId : index === 0,
    brandingColors: b.brandingColors,
    timestamp: b.timestamp,
  };
}

export interface IBrandingListModalProps {
  open: boolean;
  onClose: () => void;
  onLeaveBrandingMode: () => void;
  onCreateNew: () => void;
  brandings: IBranding[];
  brandingsLoading?: boolean;
  onToggleBranding: (id: string) => void;
  onEditBranding?: (id: string) => void;
  onCloneBranding?: (id: string) => void;
  onDeleteBranding?: (id: string) => void;
  liveBrandingId?: string | null;
  eventName?: string;
}

export interface ICreateBrandingModalProps {
  open: boolean;
  onClose: () => void;
  onStartFromScratch: () => void;
  onCloneFromExisting: () => void;
  hasExistingBrandings?: boolean;
}
